<template>
    <section class="section" style="padding-top:0;">
      <div class="container content">
        <div class="columns is-multiline">
          <div class="column is-12 has-text-centered">
            <h1 class="title is-size-3 is-size-4-mobile script primary is-spaced has-text-left-mobile">{{ view.content.headline }}</h1>
            <p class="subtitle is-size-4 is-size-6-mobile" v-if="view.content.subtitle.length">{{ view.content.subtitle }}</p>
          </div>
          <div class="column is-6">

            <span v-html="view.content.text" class="is-size-6 is-size-7-mobile"></span>

          </div>
          <div class="column is-6" id="sidebar">

            <!-- masonry images -->
            <div v-masonry transition-duration="0s" item-selector=".item" v-if="view.content.masonry.length" class="columns is-multiline">
              <div v-masonry-tile class="column is-4 item" v-for="(i, index) in view.content.masonry">
                <img :src="assetsBaseUrl + i.path" @click="$emit('showLightbox', i.path)" class="cursor">
              </div>
            </div>

            <!-- swiper -->
            <swiper :options="swiperOption" v-if="view.content.images.length">
              <swiper-slide v-for="(i, index) in view.content.images" :key="'s' + index" :style="'background-image: url(' + assetsBaseUrl + i.path + ');'"><div class="caption" v-if="i.caption.length || i.credits.length"><p class="is-size-7-mobile" style="line-height:normal;">{{ i.caption }}<br v-if="i.credits.length"><span class="is-size-7" v-if="i.credits.length">© {{ i.credits }}</span></p></div></swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>

            <div v-if="view.content.videos.length" class="videowrapper" v-for="(i, index) in view.content.videos" :key="'v' + i">
              <iframe width="560" height="315" :src="'https://www.youtube-nocookie.com/embed/' + i" frameborder="0" allowfullscreen></iframe>
            </div>

          </div>

          <div class="column is-12" v-if="view.content.tags.length">
            <app-projects-overview :content="content"></app-projects-overview>
          </div>



        </div>
      </div>
    </section>
</template>

<script>
import ProjectsOverview from '@/components/shared/ProjectsOverview'
export default {
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  props: ['view', 'lightbox', 'lightboxImg'],
  computed: {
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    },
    content () {
      return this.$store.getters.content.filter(el => el.type === 1 && this.view.content.tags.some(s => el.content.tags.indexOf(s) !== -1))
    }
  },
  components: {
    appProjectsOverview: ProjectsOverview
  }
}
</script>

<style scoped>
  .swiper-container {
    background-color: #000;
    height: 500px;
    margin-bottom: 30px;
  }
  .gallery-top {
    height: 400px;
    width: 100%;
  }
  .gallery-thumbs {
    height: 20% !important;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100px;
    opacity: 0.4;
  }
  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }

@media screen and (min-width: 1024px) {
  .swiper-container {
  width: 100% !important;
}
}

  .swiper-container .swiper-slide {
    background-position: center;
    background-size: cover;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/Topic.vue